<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('coop_ban_list')" :isFilter="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('coop_ban_list')" :isFilter="false" />
            </template>

            <b-card>
                <h6 class="mb-3">{{ $t('student_numbers') }}</h6>

                <b-form-textarea
                    :value="studentNumbersText"
                    rows="6"
                    readonly
                    class="mb-3 font-monospace"
                />

                <b-form-group class="mb-3">
                    <b-form-select v-model="selectedAction" :options="actionOptions" />
                </b-form-group>

                <b-form-group v-if="selectedAction === 'add' || selectedAction === 'remove'" class="mb-3">
                    <b-form-input
                        v-model="studentNumberInput"
                        :placeholder="$t('student_number')"
                    />
                </b-form-group>

                <div class="d-flex">
                    <b-button variant="primary" class="mr-2" :disabled="!selectedAction || isLoading" @click="execute">
                        {{ $t('start_process') }}
                    </b-button>
                    <b-button variant="outline-success" @click="exportToExcel">
                        {{ $t('excel') }}
                    </b-button>
                </div>
            </b-card>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header';
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';

    //Service
    import CoopBanListService from '@/services/CoopBanListService';

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile
        },
        metaInfo() {
            return {
                title: this.$t('coop_ban_list')
            };
        },
        data() {
            return {
                isLoading: false,
                banList: [],
                selectedAction: null,
                studentNumberInput: '',
                actionOptions: [
                    {value: null, text: this.$t('select')},
                    {value: 'add', text: this.$t('coop_ban_list_add_student')},
                    {value: 'remove', text: this.$t('coop_ban_list_remove_student')},
                    {value: 'remove_all', text: this.$t('delete_all')}
                ]
            };
        },
        computed: {
            studentNumbersText() {
                return this.banList.map((r) => r.student_number).join('\n');
            }
        },
        created() {
            this.loadList();
        },
        methods: {
            loadList() {
                CoopBanListService.getAll().then((response) => {
                    this.banList = response.data.data;
                });
            },
            execute() {
                if (this.selectedAction === 'add') {
                    if (!this.studentNumberInput) {
                        this.$toast.error(this.$t('coop_ban_list_enter_student_number'));
                        return;
                    }
                    this.isLoading = true;
                    CoopBanListService.add(this.studentNumberInput).then(() => {
                        this.$toast.success(this.$t('coop_ban_list_add_success'));
                        this.studentNumberInput = '';
                        this.loadList();
                    }).finally(() => { this.isLoading = false; });

                } else if (this.selectedAction === 'remove') {
                    if (!this.studentNumberInput) {
                        this.$toast.error(this.$t('coop_ban_list_enter_student_number'));
                        return;
                    }
                    this.isLoading = true;
                    CoopBanListService.remove(this.studentNumberInput).then(() => {
                        this.$toast.success(this.$t('coop_ban_list_remove_success'));
                        this.studentNumberInput = '';
                        this.loadList();
                    }).finally(() => { this.isLoading = false; });

                } else if (this.selectedAction === 'remove_all') {
                    this.$swal.fire({
                        text: this.$t('coop_ban_list_remove_all_confirm'),
                        showCancelButton: true,
                        confirmButtonText: this.$t('yes'),
                        cancelButtonText: this.$t('no')
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.isLoading = true;
                            CoopBanListService.removeAll().then(() => {
                                this.$toast.success(this.$t('coop_ban_list_remove_all_success'));
                                this.loadList();
                            }).finally(() => { this.isLoading = false; });
                        }
                    });
                }
            },
            exportToExcel() {
                const rows = this.banList.map((r) => r.student_number).join('\n');
                const blob = new Blob([rows], {type: 'text/plain;charset=utf-8;'});
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.setAttribute('href', url);
                link.setAttribute('download', 'ban_list.txt');
                link.click();
                URL.revokeObjectURL(url);
            }
        }
    };
</script>
